/* eslint-env node */

import { applyMiddleware, createStore } from 'redux';
import thunk from 'redux-thunk';
import api from './middleware/api';

import reducers from './reducers';

export default (initialState = {}, config = {}) => {
  let middleware = applyMiddleware(thunk, api(config));

  const store = createStore(reducers, initialState, middleware);

  if (module.hot) {
    module.hot.accept('./reducers', () => {
      const reducers = require('./reducers').default;
      store.replaceReducer(reducers);
    });
  }

  return store;
};
